export default {
  path: "/rightholder/:token",
  name: "rightholder.index",
  component: () => import("@/views/Register/NewUser/Index.vue"),
};
